var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1616 13.7364C16.2574 13.4311 16.3117 13.1077 16.3117 12.7714V12.3849H16.3368C17.1178 12.3849 17.7536 11.7495 17.7536 10.9683C17.7536 10.7729 17.7133 10.5818 17.6338 10.4001L17.6308 10.3928L17.6274 10.3858L16.5484 8.01527L18.389 8.30918L18.5555 7.26654L17.0716 7.02944C17.0703 7.02641 17.0701 7.023 17.0688 7.01991L14.993 2.42355C14.9268 2.27694 14.7973 2.1682 14.6412 2.12883L6.28713 0.0164163C6.05691 -0.0423156 5.81734 0.0601713 5.69943 0.265825L3.1003 4.79738L1.67079 4.56927L1.50425 5.61191L3.63409 5.95206C3.47305 6.51574 3.38504 7.1095 3.38504 7.72399C3.38504 8.8693 3.68179 9.963 4.23033 10.9217L2.19143 10.4407L3.35914 14.3558C1.4641 15.0892 0.101082 16.8838 0 19.0123H17.4358L16.7922 16.4402L18.4008 14.2645L16.1616 13.7364ZM4.44109 7.72398C4.44109 7.16537 4.52606 6.62656 4.68332 6.11966L15.2974 7.81539L16.6664 10.8228H16.6658C16.6856 10.8677 16.6972 10.9161 16.6972 10.9682C16.6972 11.1679 16.536 11.3287 16.3367 11.3287H15.2555V12.7714C15.2555 13.0248 15.2095 13.2669 15.1296 13.4931L5.79385 11.2905C4.95409 10.3391 4.44115 9.09301 4.44115 7.72397L4.44109 7.72398Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgExample);
export default __webpack_public_path__ + "static/media/SvgExample.da2e41c565cbe54f3dce36a6ce0f607e.svg";
export { ForwardRef as ReactComponent };